import { makeStyles } from "@material-ui/core";

export const useReturnIssuedPartStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialogContent-root": {
      padding: "26px 85px",
    },
  },

  modal: {
    "& .MuiDialog-paperWidthLg": {
      minWidth: "750px",
      // padding: "26px 85px",
      // height: "110vh"
    },
  },

  bodyText: {
    marginBottom: "24px",
    fontSize: "16px",
    color: "#4D4F5C",
    textAlign: "center",
  },

  qrContainer: {
    position: "fixed",
    width: "100vw",
    height: "100vh",
    top: 0,
    left: 0,
    background: "rgba(0,0,0,.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all .5s",
    zIndex: 9,
  },

  heading: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "25px"
  },

  firstStepRoot: {
    "& .MuiButtonGroup-root": {
      marginBottom: "15px"
    }
  },
  layout: {
    width: '250px',
    height: '377px',
    fontSize: '11px',

  },
  leftSection: {
    paddingLeft: '5px',
    // paddingBottom: '2px',
    color: theme.palette.primary.main
  },
  rightSection: {
    paddingLeft: '5px',
    // paddingBottom: '2px',

  },
  qrCode: {
    textAlign: 'center',
    display: 'block',
    paddingBottom: '4px',
  }
}));
